import React from 'react'
import { useMemo,useState, useEffect } from "react"
import "./MoznostiTarifyForm.css";
import { authHeader } from '../_helpers';
import { useTable, useSortBy, useGlobalFilter} from "react-table";
import GlobalFilter from "../_components/GlobalFilterUziv"
import { AiOutlineClear } from "react-icons/ai";

const MoznostiTarifyForm = () => {
    const [values,setValues]=useState([])
    const [options,setOptions]=useState()
    const [fivalues,setFivalues]=useState([]);
    const [fioptions,setFioptions]=useState();
    const [inputs, setInputs] = useState({});
    const baseUrl = `${process.env.REACT_APP_API_URL}`;
    const user = JSON.parse(localStorage.getItem('user'));
    const [sloptions,setSloptions]=useState();
    const [slvalues,setSlvalues]=useState([]);
    const firma = JSON.parse(localStorage.getItem('firma'));

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([]);
   
    const [tarif, setTarif] = useState({
        cis_ID: '',
        cis_fi: '',
        cis_pop: '',
        cis_kc: '',
        cis_mj: '',
        cis_stav: ''
    });

    const columns = useMemo(
        () => [
          { Header: "Číslo tarifu", accessor: "cis_id" },
          { Header: "Popis", accessor: "cis_pop" },
          { Header: "Kč", accessor: "cis_kc" },
          { Header: "Množství", accessor: "cis_mj" }
        ],
        []
      );
    
      const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        state,
        setGlobalFilter
      } = useTable({ columns, data }, useGlobalFilter, useSortBy);
    
      const { globalFilter} = state

    // reset login status

    

    

    
    /*
    const init = (selectedID) => {
        
            //var prac = fioptions.substring(0, fioptions.indexOf(":"));
            zarizeni.z_fi = firma[0].fi_ID;
            let parametr = selectedID.replace(/#/gi, "-");
            const requestOptions = {
                method: 'GET',
                headers: authHeader(),
            };
        //fetch("http://localhost:4000/api/klient/"+ selectedID, requestOptions).then((data)=>data.json()).then((val)=>setInputs(val))
        fetch(process.env.REACT_APP_API_URL+'/api/private/zarizenidetail/'+zarizeni.z_fi+'/'+parametr, requestOptions)
            .then(response => response.json())
            .then(data => {
                //setInputs(data)
                //console.log(data);
                var jmeno;
                var par;
                var typ;
                var firma;

                data.map((obj) => {
                    return  jmeno=obj.z_jmeno,
                            par=obj.z_par,
                            typ=obj.z_typ,
                            firma=obj.z_fi
                })  
                
                setZarizeni({
                    z_jmeno: jmeno,
                    z_fi: firma,
                    z_par: par,
                    z_stat: '0',
                    z_typ: typ
                    });
            })
            .catch(error => {
                console.log("err")
            });   
    }
    */
    

    function handleSubmit(e) {
        e.preventDefault();
            
            //var prac = fioptions.substring(0, fioptions.indexOf(":"));
            tarif.cis_fi = firma[0].fi_ID;
            tarif.cis_stav = 1;
            const requestOptions = {
                method: 'POST',
                headers: { ...authHeader(), 'Content-Type': 'application/json' },
                body: JSON.stringify(tarif)
            };
            console.log(tarif);
            clearForm();
            fetchData();
            
            return fetch(`${process.env.REACT_APP_API_URL}/api/private/newtarif`, requestOptions).then(handleResponse);
        
    }

    function deleteKlient() {
              
            tarif.cis_fi = firma[0].fi_ID;
            tarif.cis_stav = 9;
            const requestOptions = {
                method: 'POST',
                headers: { ...authHeader(), 'Content-Type': 'application/json' },
                body: JSON.stringify(tarif)
            };
            
            clearForm();
            return fetch(`${process.env.REACT_APP_API_URL}/api/private/newtarif`, requestOptions).then(handleResponse);
            
            
    }

    const clearForm = () => {
        setTarif({
            cis_ID: '',
            cis_fi: '',
            cis_pop: '',
            cis_kc: '',
            cis_mj: '',
            cis_stav: ''
        });
        setSloptions();
        setFioptions();
        setSlvalues([]);
        setFivalues([]);
        setLoading(true);
        setTimeout(function() {
        fetchData();
        setLoading(false);
      }, 1000); 
    }

    function handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            if (response.status === 200) {
                console.log("POSTED")
            } else {console.log("ERR"); alert("Špatně zvolené jméno nebo heslo, zkuste znovu.");}
            if (!response.ok) {
                if (response.status === 401) {
                    // auto logout if 401 response returned from api
                    //logout();
                    //location.reload(true);
                }
                if (response.status === 200) {
                    console.log("POSTED")
                }
    
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
    
            return data;
        });
    }

    const handleFormSubmit = (event) => {
        event.preventDefault();
        
        
        fetchData();
      }

    function handleRowClick(ID, popis, kc, mj) {
        // console.log(slpname);
        setTarif({
            cis_ID: ID,
            cis_fi: firma[0].fi_ID,
            cis_pop: popis,
            cis_kc: kc,
            cis_mj: mj
        }); 
       }

    const fetchData = async () => {
        console.time('VolaniAPI');
        
        setLoading(true);
        try {
          
          const requestOptions = {
            method: 'GET',
            headers: authHeader()
          };
          const user = JSON.parse(localStorage.getItem('user'));
          const apiurl = process.env.REACT_APP_API_URL+"/api/private/tarif/"+user.u_fi;
          console.log(apiurl);
          const response = await fetch( apiurl, requestOptions);
          const apidata = await response.json();
          setData(apidata);
        } catch (error) {
          console.error("Error fetching data:", error);
        } 
        console.timeEnd('VolaniAPI');
        
        setLoading(false)
        
      };
    
    useEffect(()=>{
        //fetchDropDown();
        fetchData();
    },[])

    return (
      <>
            
            <form name="formKlienti" onSubmit={handleSubmit}>
                <section id="formInfo">
                
                          
                            
                                 
                       <label className='lblKlienti'>
                            <input 
                                type="text" 
                                name="cis_ID" 
                                value={tarif.cis_ID} 
                                onChange={(e) =>
                                    setTarif({ ...tarif, cis_ID: e.target.value })
                                } 
                                className="inputKlienti"
                                required="required"
                                placeholder=" "
                            />
                            <span>Číslo</span>
                        </label>

                        <label className='lblKlienti'>
                            <input 
                                type="text" 
                                name="cis_pop" 
                                value={tarif.cis_pop} 
                                onChange={(e) =>
                                    setTarif({ ...tarif, cis_pop: e.target.value })
                                } 
                                className="inputKlienti"
                                required="required"
                                placeholder=" "
                            />
                            <span>Popis</span>
                        </label>
                        
                        <label className='lblKlienti'>
                            <input 
                                type="number" 
                                name="cis_kc" 
                                value={tarif.cis_kc} 
                                onChange={(e) =>
                                    setTarif({ ...tarif, cis_kc: e.target.value })
                                } 
                                className="inputKlienti"
                                required="required" 
                                placeholder=" "
                            />
                            <span>Cena v Kč</span>
                        </label>
                        <label className='lblKlienti'>
                            <input 
                                type='number'
                                name="cis_mj" 
                                value={tarif.cis_mj} 
                                onChange={(e) =>
                                    setTarif({ ...tarif, cis_mj: e.target.value })
                                } 
                                className="inputKlienti"
                                required="required"
                                placeholder=" "
                            /> 
                            <span>Množství</span>
                        </label> 
                             
                        
                        <section className="formButtons">
                    <button type='submit' className='btnKlientiSubmit'>
                        Odeslat
                    </button>
                    <button onClick={deleteKlient} className='btnDelete'>
                        Vymazat
                    </button>
                    <button onClick={clearForm} className='btnClr'>
                    <AiOutlineClear />
                    </button>       

                </section>  
                </section>
                
            </form>
            <div className="containerInputsUziv">
      <form className="formInputsUziv" onSubmit={handleFormSubmit} >   
      </form>
      <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
      </div>
    <div className="containerUziv">
        
      {
      loading ?
          <div id="tablespinner" className="spinner-border"></div>
          :                                                         
          <table id="tableZar" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td onClick={() => handleRowClick(row.original.cis_id, row.original.cis_pop, row.original.cis_kc, row.original.cis_mj)} {...cell.getCellProps()}>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
      }
    </div>  
      </>
    )
}

export default MoznostiTarifyForm;